import { render, staticRenderFns } from "./MainContentLoader.vue?vue&type=template&id=29d4b630&scoped=true&lang=pug"
import script from "./MainContentLoader.vue?vue&type=script&lang=js"
export * from "./MainContentLoader.vue?vue&type=script&lang=js"
import style0 from "./MainContentLoader.vue?vue&type=style&index=0&id=29d4b630&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29d4b630",
  null
  
)

export default component.exports